<template>
    <div class="_text-center">
        <template v-if="errorpage === 'org'">
            <p>Missing organization. Missing or wrong configuration.</p>
        </template>
        <template v-if="errorpage === 'signer'">
            <p>Signer doesn't exists. Missing or wrong configuration.</p>
        </template>
        <template v-else>
            <p>Missing or wrong configuration.</p>
        </template>
    </div>
</template>

<script>
export default {
    computed: {
        errorpage: function() {
            return this.$route.params.type;
        }
    }
};
</script>
